module.exports = __webpack_public_path__ + "img/r5.3cd8ec65.png";